/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData model module.
 * @module model/EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData
 * @version 1.0
 */
class EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData {
    /**
     * Constructs a new <code>EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData</code>.
     * @alias module:model/EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData
     */
    constructor() { 
        
        EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData} obj Optional instance to populate.
     * @return {module:model/EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData} The populated <code>EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData();

            if (data.hasOwnProperty('accountNo')) {
                obj['accountNo'] = ApiClient.convertToType(data['accountNo'], 'Number');
            }
            if (data.hasOwnProperty('marketListingNo')) {
                obj['marketListingNo'] = ApiClient.convertToType(data['marketListingNo'], 'Number');
            }
            if (data.hasOwnProperty('postNo')) {
                obj['postNo'] = ApiClient.convertToType(data['postNo'], 'Number');
            }
            if (data.hasOwnProperty('tokenType')) {
                obj['tokenType'] = ApiClient.convertToType(data['tokenType'], 'Number');
            }
            if (data.hasOwnProperty('marketPrice')) {
                obj['marketPrice'] = ApiClient.convertToType(data['marketPrice'], 'Number');
            }
            if (data.hasOwnProperty('reward')) {
                obj['reward'] = ApiClient.convertToType(data['reward'], 'Number');
            }
            if (data.hasOwnProperty('exchangeRate')) {
                obj['exchangeRate'] = ApiClient.convertToType(data['exchangeRate'], 'Number');
            }
            if (data.hasOwnProperty('createdAt')) {
                obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData</code>.
     */
    static validateJSON(data) {

        return true;
    }


}



/**
 * @member {Number} accountNo
 */
EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.prototype['accountNo'] = undefined;

/**
 * @member {Number} marketListingNo
 */
EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.prototype['marketListingNo'] = undefined;

/**
 * @member {Number} postNo
 */
EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.prototype['postNo'] = undefined;

/**
 * @member {Number} tokenType
 */
EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.prototype['tokenType'] = undefined;

/**
 * @member {Number} marketPrice
 */
EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.prototype['marketPrice'] = undefined;

/**
 * @member {Number} reward
 */
EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.prototype['reward'] = undefined;

/**
 * @member {Number} exchangeRate
 */
EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.prototype['exchangeRate'] = undefined;

/**
 * @member {Date} createdAt
 */
EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData.prototype['createdAt'] = undefined;






export default EventsControllerDtoEventInvitationPartnerDetailEventInvitationPartnerDetailListData;

